import { Cogwheel, Cross, User } from '@oriola-corporation/kronan-icons';
import { Button, Chip, COLORS, Forms } from '@oriola-corporation/ui-components';
import React, { useState } from 'react';
import styled from 'styled-components';
import { useCurrentUser } from '.';

interface Props {
  name: string;
  link: string;
}

export const Header: React.FC<Props> = ({ name, link }) => {
  const {
    pharmacyId,
    username,
    logout,
    isSuperAdmin,
    hasSwitchedPharmacy,
    switchPharmacy,
    clearPharmacy,
  } = useCurrentUser();
  const [isInputShowing, setIsInputShowing] = useState<boolean>(false);
  const [pharmacyForm, setPharmacyForm] = useState<string>('');

  const isAcc1 = window.location.host.includes('acc1');

  return (
    <NavBar $isAcc1={isAcc1}>
      <HeaderWrapper>
        <CenteredRow>
          <a href="/">
            <Logo
              src={
                isAcc1
                  ? 'https://assets.kronansapotek.se/images/logo/KRONAN_logotyp_liggande_gray.svg'
                  : 'https://assets.kronansapotek.se/images/logo/KRONAN_logotyp_liggande_orange.svg'
              }
              alt="Kronan logo"
            />
          </a>
          <Link href="/">E-HANDELSPORTALEN 2.0</Link>
          <span style={{ fontWeight: 600 }}>{'>'}</span>
          <Link href={link}>{name}</Link>
        </CenteredRow>
        <LoggedInWrapper>
          <Chip icon={<User />}>
            <CenteredRow>
              {username}
              {isSuperAdmin && !hasSwitchedPharmacy && (
                <PharmacyChangeIcon onClick={() => setIsInputShowing(!isInputShowing)}>
                  <Cogwheel />
                </PharmacyChangeIcon>
              )}
            </CenteredRow>
          </Chip>
          {hasSwitchedPharmacy && (
            <Chip
              icon={
                <PharmacyChangeIcon
                  onClick={() => {
                    clearPharmacy();
                    setIsInputShowing(false);
                  }}
                >
                  <Cross />
                </PharmacyChangeIcon>
              }
            >
              {pharmacyId}
            </Chip>
          )}
          {isInputShowing && isSuperAdmin && !hasSwitchedPharmacy && (
            <form
              action="submit"
              onSubmit={(e) => {
                e.preventDefault();
                switchPharmacy(pharmacyForm);
              }}
            >
              <Forms.Elements.Input
                placeholder={pharmacyId || 'Välj apoteksid'}
                onChange={(e) => setPharmacyForm(e.target.value)}
                onBlur={() => switchPharmacy(pharmacyForm)}
              />
            </form>
          )}

          <Button size="small" variant="secondary" onClick={() => logout()}>
            Logga ut
          </Button>
        </LoggedInWrapper>
      </HeaderWrapper>
    </NavBar>
  );
};

const CenteredRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const PharmacyChangeIcon = styled.div`
  &:hover {
    cursor: pointer;
  }
`;

const HeaderWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
`;

const LoggedInWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const NavBar = styled.nav<{ $isAcc1: boolean }>`
  border-top: 12px solid ${({ $isAcc1 }) => ($isAcc1 ? COLORS.GRAY_DARKER : COLORS.BRAND)};
  background: ${COLORS.WHITE};
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 10px 18px 0px rgba(0, 0, 0, 0.03);
`;

const Logo = styled.img`
  height: 24px;
  margin: 0px 32px;
  min-width: 150px;
`;

const Link = styled.a`
  text-decoration: none;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 1.17px;
  color: #493e35;
  text-decoration: none;
`;
